import { inject, Injectable } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HISTORY_API_BASE_URL } from '../../api-base-url.token';
import { BidHistoryResponseDto } from '../../schemas/bid-responses/bid-history-response.dto';

@Injectable({ providedIn: 'root' })
export class BidHistoryAdminApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(HISTORY_API_BASE_URL)}/bidHistoryAdmin`;

    getAll(auctionId: number) {
        return this.builder
            .url(`${this.controllerUrl}/getAll`)
            .get()
            .json<BidHistoryResponseDto[]>()
            .withHttpParams(new HttpParams().set('auctionId', auctionId))
            .build()
            .send();
    }

    getById(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/getById`)
            .get()
            .json<BidHistoryResponseDto>()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }
}
